import { render, staticRenderFns } from "./FormCustomer.vue?vue&type=template&id=61e210bc&scoped=true"
import script from "./FormCustomer.vue?vue&type=script&lang=js"
export * from "./FormCustomer.vue?vue&type=script&lang=js"
import style0 from "./FormCustomer.vue?vue&type=style&index=0&id=61e210bc&prod&lang=scss"
import style1 from "./FormCustomer.vue?vue&type=style&index=1&id=61e210bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e210bc",
  null
  
)

export default component.exports